// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergyBillReconcilliation_Bus_engBlReconTitleChart_Bus__tBkDs {
  font-size: 0.9em;
  color: #0e3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #e0e0e0;
  border-radius: 5px 5px 0 0;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}
.EnergyBillReconcilliation_Bus_tableContent_Bus__5TJ2I table tr td {
  font-size: 0.8em;
}
.EnergyBillReconcilliation_Bus_main_hole_background__KozvO {
  background-color: #f2f3fc;
  /* height: calc(100vh - 58px); */
  /* height: calc(100vh - 8px); */
  /* height: calc(100vh); */
}

.EnergyBillReconcilliation_Bus_reconcilChartboxNew_Bus__P600l {
  background: #ffffff;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  /* height: 293px; */
  /* height: calc(100vh - 150px); */
  border-radius: 5px 5px 0 0;
}

.EnergyBillReconcilliation_Bus_chargingChartboxNew2_Bus__HlFcY {
  background: #ffffff;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  height: 313px;
  border-radius: 5px 5px 0 0;
}
.EnergyBillReconcilliation_Bus_filter_bus_icon_f__cVU0F .EnergyBillReconcilliation_Bus_rca_btn__FJ2c9 .EnergyBillReconcilliation_Bus_rca_btn_bus__KKS6W {
  background-color: #ffa650;
}
.EnergyBillReconcilliation_Bus_filter_bus_icon_f__cVU0F .EnergyBillReconcilliation_Bus_rca_btn__FJ2c9 .EnergyBillReconcilliation_Bus_rca_btn_bus__KKS6W:hover {
  background-color: #fcb877 !important;
  border-color: #fcb877 !important;
}

.EnergyBillReconcilliation_Bus_downloadButton__u8jfn,
.EnergyBillReconcilliation_Bus_downloadButton__u8jfn:active,
.EnergyBillReconcilliation_Bus_downloadButton__u8jfn:focus-within {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.EnergyBillReconcilliation_Bus_downloadButton__u8jfn:hover {
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/EnergyBillReconcilliation_Bus/EnergyBillReconcilliation_Bus.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC","sourcesContent":[".engBlReconTitleChart_Bus {\n  font-size: 0.9em;\n  color: #0e3157;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-align: center;\n  background: #e0e0e0;\n  border-radius: 5px 5px 0 0;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n.tableContent_Bus table tr td {\n  font-size: 0.8em;\n}\n.main_hole_background {\n  background-color: #f2f3fc;\n  /* height: calc(100vh - 58px); */\n  /* height: calc(100vh - 8px); */\n  /* height: calc(100vh); */\n}\n\n.reconcilChartboxNew_Bus {\n  background: #ffffff;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  /* height: 293px; */\n  /* height: calc(100vh - 150px); */\n  border-radius: 5px 5px 0 0;\n}\n\n.chargingChartboxNew2_Bus {\n  background: #ffffff;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  height: 313px;\n  border-radius: 5px 5px 0 0;\n}\n.filter_bus_icon_f .rca_btn .rca_btn_bus {\n  background-color: #ffa650;\n}\n.filter_bus_icon_f .rca_btn .rca_btn_bus:hover {\n  background-color: #fcb877 !important;\n  border-color: #fcb877 !important;\n}\n\n.downloadButton,\n.downloadButton:active,\n.downloadButton:focus-within {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n}\n\n.downloadButton:hover {\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"engBlReconTitleChart_Bus": `EnergyBillReconcilliation_Bus_engBlReconTitleChart_Bus__tBkDs`,
	"tableContent_Bus": `EnergyBillReconcilliation_Bus_tableContent_Bus__5TJ2I`,
	"main_hole_background": `EnergyBillReconcilliation_Bus_main_hole_background__KozvO`,
	"reconcilChartboxNew_Bus": `EnergyBillReconcilliation_Bus_reconcilChartboxNew_Bus__P600l`,
	"chargingChartboxNew2_Bus": `EnergyBillReconcilliation_Bus_chargingChartboxNew2_Bus__HlFcY`,
	"filter_bus_icon_f": `EnergyBillReconcilliation_Bus_filter_bus_icon_f__cVU0F`,
	"rca_btn": `EnergyBillReconcilliation_Bus_rca_btn__FJ2c9`,
	"rca_btn_bus": `EnergyBillReconcilliation_Bus_rca_btn_bus__KKS6W`,
	"downloadButton": `EnergyBillReconcilliation_Bus_downloadButton__u8jfn`
};
export default ___CSS_LOADER_EXPORT___;
